export const MenuItems = [
    {
        title:'Home',
        url:'home',
        cName:'nav__item',
        icon:'ri-home-5-line',
        cNameLink:'nav__link',
        ActiveLink:'nav__link active-link',
    },
    {
        title:'Skills',
        url:'skills',
        cName:'nav__item',
        icon:'ri-trophy-line',
        cNameLink:'nav__link',
        ActiveLink:'active-link',
    },
    {
        title:'Services',
        url:'services',
        cName:'nav__item',
        icon:'ri-briefcase-line',
        cNameLink:'nav__link',
        ActiveLink:'nav__link active-link',
    },
    {
        title:'Projects',
        url:'projects',
        cName:'nav__item',
        icon:'ri-image-line',
        cNameLink:'nav__link',
        ActiveLink:'nav__link active-link',
    },
    {
        title:'Testimonial',
        url:'testimonial',
        cName:'nav__item',
        icon:'ri-question-answer-line',
        cNameLink:'nav__link',
        ActiveLink:'nav__link active-link',
    },
    {
        title:'Contact',
        url:'contact',
        cName:'nav__item',
        icon:'ri-chat-3-line',
        cNameLink:'nav__link',
        ActiveLink:'nav__link active-link',
    },
]